function mmPcChangeVariant(clickedElem, variantId, inventoryQuantity, showCta) {
  const productCard = clickedElem.closest('.mm-product-card');

  // Change ID
  const inputId = productCard.querySelector('.mm-pc-selected-variant-id');
  inputId.dataset.variantId = variantId;

  // CHange Inventory Qtty
  const iventoryWrapper = productCard.querySelector('.mm-pc-remaining-qtty');
  const iventoryTextData = productCard.querySelector('.mm-pc-remaining-qtty-text span');
  const cta = productCard.querySelector('.mm-product-card-CTA');
  
  iventoryTextData.innerText = inventoryQuantity;  
  if (inventoryQuantity > 5){
    iventoryWrapper.style.display = "none";
  } else if (inventoryQuantity <= 0) {
    iventoryWrapper.style.display = "none";
  } else {
    iventoryWrapper.style.removeProperty('display');
  }

  // CTA
  if (showCta) {
    cta.classList.remove('mm-disabled');    
  } else {
    cta.classList.add('mm-disabled');    
  }

  // Check button
  const buttons = productCard.querySelectorAll('.mm-product-card-product-variant');
  buttons.forEach(function(button) {
    button.classList.remove('mm-checked');
  })
  clickedElem.classList.add('mm-checked');
}

function changeText (clickedCta, textToDisplay) {
  const ctaText = clickedCta.querySelector('.mm-product-card-CTA-text')
  ctaText.innerText = textToDisplay;
};

// VARIANT SELECTOR ==========================================================================================

function mmUpdatePcVariantSelector(variantSelector) {
  const productCard = variantSelector.closest('.mm-product-card');
  const input = productCard.querySelector('.mm-product-card-CTA');
  const variantInfos = getVariantInfos(variantSelector, productCard);

  // Update variant id
  if (variantInfos) {
    input.dataset.variantId = variantInfos.id;    
  
    // Update image
    const currentImageElem = productCard.querySelector('.mm-product-card_img');
    if(variantInfos.featured_image) {
      const newImage = variantInfos.featured_image.src;
      if(currentImageElem.src != newImage) {
        currentImageElem.src = newImage;
        currentImageElem.srcset = newImage;
      }    
    }
  
    // Update remaining stocks
    const stocksElem = productCard.querySelector('.mm-pc-remaining-qtty');
    const stocksInfo = productCard.querySelector('.mm-pc-remaining-qtty-text span');
    const stocks = getStocksByVariantId(variantInfos.id, productCard);
    if(stocks <= 5 && stocks > 0) {
      stocksElem.style.display = 'flex';
    } else {
      stocksElem.style.display = 'none';    
    }
    stocksInfo.innerText = stocks;
  
    console.log('stocks', stocks)
  
    // UPDATE CTA
    const CTA = productCard.querySelector('.mm-product-card-CTA');
    const CTAprice = productCard.querySelector('.mm-pc-cta-price');
  
    if (stocks > 0) {
      CTA.classList.remove('mm-disabled');    
    } else {
      CTA.classList.add('mm-disabled');
    }
      console.log('variantInfos.price', variantInfos.price)
    if(CTAprice) {
      console.log('variantInfos.price', variantInfos.price)
      CTAprice.innerText = `${formatPrice((variantInfos.price / 100).toFixed(2))}€`    
    }
    console.log('variant infos', variantInfos);
  }
  
}

function formatPrice(priceStr) {
  const price = parseFloat(priceStr);
  console.log('price', price)
  // Utiliser toFixed(2) pour obtenir le prix avec deux décimales
  const priceWithDecimals = price.toFixed(2);

  // Vérifier si les décimales sont "00"
  if (priceWithDecimals.endsWith('00')) {
    // Retourner le prix sans les décimales
    return Math.round(price).toString();
  } else {
    // Sinon, retourner le prix avec deux décimales
    return priceWithDecimals;
  }
}

function getVariantInfos(variantSelector, productCard) {
  const selectedOptions = Array.from(productCard.querySelectorAll(".mm-pc-variant-checkbox:checked"), (checkbox) => checkbox.value);
  const parsedJson = JSON.parse(productCard.querySelector('[type="application/json"]').textContent);

  const currentVariant = parsedJson.find((variant) => {
    // Assurez-vous de renvoyer le bon résultat de la fonction `map`.
    const findings = !variant.options
      .map((option, index) => selectedOptions[index] === option)
      .includes(false);

    return findings;
  });
  console.log('currentVariant', currentVariant)

  return currentVariant ? currentVariant : null;
}

function getStocksByVariantId(variantId, productCard) {
  const selectElement = productCard.querySelector('.mm-pc-variants-stocks');
  
  for (let i = 0; i < selectElement.options.length; i++) {
    const option = selectElement.options[i];
    if (parseInt(option.value) == variantId) {
      return option.dataset.stocks;
    }
  }
  
  return null;
}

function mmProductCardShowAllVariantSelectors(clickedElem) {
  const product_card = clickedElem.closest('.mm-product-card');
  const elems_to_show = product_card.querySelectorAll('.mm-product-card-product-variant-extra');

  clickedElem.style.display = 'none';
  elems_to_show.forEach(function(elem_to_show) {
    elem_to_show.classList.remove('mm-hidden');
  })
}


















